// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import moment from 'moment-timezone'
import DOMPurify from 'dompurify'
import { sanitizeNoteHtml, DOMPURIFY_CONFIG } from '../../../utils/noteHtmlSanitizer'
import { RemarksAuthor } from './RemarksAuthor'
import { DATE_TIME_FORMAT_EXTEND } from '../../../utils/dateUtils'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const RemarksContent = ({ remarksList, userTimeZone }) =>
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  remarksList?.map(({ Author, DateTime, Message }, index) => {
    const date = moment(DateTime).parseZone().tz(userTimeZone, false).format(DATE_TIME_FORMAT_EXTEND)

    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index}>
        {index ?
          <hr className='remarks-divider' />
        : null}
        <div className='remarks-date-time'>{date}</div>
        {!Author && (
          <div
            className='remarks-message'
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sanitizeNoteHtml(Message), DOMPURIFY_CONFIG) }}
          />
        )}
        {Author ?
          <div
            className='remarks-message'
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sanitizeNoteHtml(Message), DOMPURIFY_CONFIG) }}
          />
        : null}
        {Author ?
          <RemarksAuthor data={Author} index={index} />
        : <div className='remarks-author system-generated'>System generated</div>}
      </div>
    )
  })
